import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="header-glass">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <h1 className="text-glow">Dhwani</h1>
            </Link>
            <nav className="nav">
              <ul className="nav-list">
                <li><a href="/#home" className="nav-link">Home</a></li>
                <li><a href="/#events" className="nav-link">Events</a></li>
                <li><Link to="/results" className="nav-link">Results</Link></li>
                <li><Link to="/gallery" className="nav-link">Gallery</Link></li>
                <li><Link to="/brochure" className="nav-link">Brochure</Link></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;